import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const LaborsSummary = (params) => {
  return (
    <UserInterface>
      <div className="inner-content row mx-0">
        <div className="container d-flex flex-wrap">
          <div class="shadowclass">
            <h4 class="event-alert">
              Give up the excel sheets and manage your employees with a single,
              secure tool. Take the time to go to start adding team members, their
              particulars, and their terms of employment into parameter fields that
              can be used to automate the management of your workforce.{" "}
            </h4>
          </div>

          <div class="row">
            <div class="col-md-6 py-4 pe-2 row mx-0">
              <div class="shadowclass">
                <img src="/img/step2-1.png" class="img-responsive" />
              </div>
            </div>

            <div class="col-md-6 py-4 ps-2 row mx-0">
              <div class="shadowclass">
                <img src="/img/step2-2.png" class="img-responsive" />
              </div>
            </div>
          </div>

          <div className="row mx-0 w-100">
            <div class="btns d-flex justify-content-end py-4 col-12 px-0">
              <button type="Submit"> Next </button>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default LaborsSummary;
